// src/utils/memoryStorage.js
class MemoryStorage {
  constructor() {
    this.data = new Map();
  }

  setItem(key, value) {
    // 如果是对象，直接存储（不需要 JSON 序列化）
    this.data.set(key, value);
  }

  getItem(key) {
    return this.data.get(key) || null;
  }

  removeItem(key) {
    this.data.delete(key);
  }

  clear() {
    this.data.clear();
  }

  // 为了兼容性，添加一个检查是否存在的方法
  hasItem(key) {
    return this.data.has(key);
  }
}

// 创建并导出单例实例
export const memoryStorage = new MemoryStorage();